import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import {
  SubscribeRequestDto,
  SubscribeResponseDto,
  ActivateTrialSubscriptionRequestDto,
} from '../models/PaymentDTO';
import { RegistrationApiRepository } from '../../../../core/repositories/registration-api-repository';
import {
  toActivateTrialSubscriptionRequestDTO,
  toAddActiveSubscriptionDataRequestDTO,
  toSubscribeRequestDTO,
} from '../mappers/dto-mappers';
import {
  PaymentData,
  UpgradeFreeTrialPaymentData,
} from '../models/PaymentData';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends RegistrationApiRepository {
  constructor() {
    super();
  }

  completePayment(paymentData: PaymentData): Observable<SubscribeResponseDto> {
    const path = '/subscriptions/subscribe';

    const payload = toSubscribeRequestDTO(paymentData);

    return this.post<SubscribeRequestDto, SubscribeResponseDto>(path, payload);
  }

  addFreeTrialPayment(
    paymentData: UpgradeFreeTrialPaymentData,
    subscriptionId: string | undefined,
  ): Observable<SubscribeResponseDto> {
    if (!subscriptionId) {
      return EMPTY;
    }
    const path = `/subscriptions/${subscriptionId}/billing/paymentDetails`;

    const payload = toAddActiveSubscriptionDataRequestDTO(paymentData);

    return this.post<ActivateTrialSubscriptionRequestDto, SubscribeResponseDto>(
      path,
      payload,
    );
  }

  reactivateCanceledSubscription(
    paymentData: UpgradeFreeTrialPaymentData,
    subscriptionId: string | undefined,
  ): Observable<SubscribeResponseDto> {
    if (!subscriptionId) {
      return EMPTY;
    }

    const path = `/subscriptions/${subscriptionId}/reactivate`;

    const payload = toActivateTrialSubscriptionRequestDTO(paymentData);

    return this.post<ActivateTrialSubscriptionRequestDto, SubscribeResponseDto>(
      path,
      payload,
    );
  }

  validatePurchaseIntent(purchaseIntentId: string): Observable<void> {
    const url = `/PurchaseIntents/${purchaseIntentId}/validate`;
    return this.get<void>(url);
  }
}
